import { inject, Injectable } from '@angular/core';
import { OnboardingFacade } from '@zero/onboarding/domain';
import { commonRoutes } from 'constants/web-app-constants';
import { combineLatest, filter, map, Observable, of, switchMap } from 'rxjs';
import { LoggedInGuard } from './logged-in.guard';

@Injectable({
  providedIn: 'root',
})
export class KYCDoneGuard extends LoggedInGuard {
  readonly #onboardingFacade = inject(OnboardingFacade);

  public override checkUrlAllowed(url: string): Observable<boolean> {
    return super.checkUrlAllowed(url).pipe(
      switchMap(() => {
        return combineLatest([this.authService.isCustomer$(), this.authService.isPotentialCustomer()]).pipe(
          switchMap(([isCustomer, isPotentialCustomer]) => {
            if (isCustomer) {
              return of(true);
            }

            if (isPotentialCustomer) {
              this.#onboardingFacade.loadOnboardingData();
              return this.#onboardingFacade.onboardingData$.pipe(
                filter((onboardingData) => !!onboardingData),
                map((onboardingData) => {
                  if (onboardingData.status === 'IDENTIFICATION_SUCCESS') {
                    return true;
                  }
                  this.router.navigate([commonRoutes.postlogin.onboarding.redirect]);
                  return false;
                }),
              );
            }

            return of(false);
          }),
        );
      }),
    );
  }
}
